import { useEffect } from "react";
import "./App.css";
import AppRoutes from "./Routes/AppRoutes";
import { useLocation } from "react-router-dom";
import Aos from "aos";

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    Aos.init();
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <>
      <AppRoutes />
    </>
  );
}

export default App;
